jQuery(document).ready(function() {
	jQuery( ".search" ).click(function() {
		jQuery( this ).toggleClass( "highlight" );
	});
});